import React, { useEffect, useState } from 'react';
import PackageList from './PackageList';

function LanguagesSpecial(props) {
    
    const [LanguagesSpecial, setLanguagesSpecial] = useState([]);
    
    useEffect(() => {
        const getLanguagesSpecial = props.packages.filter(data => {
            return (data.productID === "PK_EP_269" || data.productID === "PK_EP_270" || data.productID === "PK_EP_271")
        });
        setLanguagesSpecial(getLanguagesSpecial)
      }, []);
    
    return (
        <>
            <h2 className="family-header">Languages Vocabulary Onscreen</h2>
            <p className="important free-languages-message">
                    Please note - due to high demand your order might take longer than normal to process. 
                    <br></br>
                    We thank you for your patience and understanding.
            </p>
            <PackageList
            packages={LanguagesSpecial}
            addToBasket={props.addToBasket}
            basket={props.basket}
            removePackageFromBasket={props.removePackageFromBasket}
            site={props.site}
            freePackage={props.freePackage}
            />
        </>
    );
}

export default LanguagesSpecial;